// import React, { useState } from 'react';
// import InstaScanner from './InstaScannerComponent'; 

// const DonaQRCodeTestScan = () => {
//   const [scannedData, setScannedData] = useState('');

//   const handleScan = data => {
//     setScannedData(data);
//   };

//   return (
//     <div>
//       <h1>QR Code Scanner</h1>
//       <InstaScanner onScan={handleScan} />
//       {scannedData && <p>Scanned Data: {scannedData}</p>}
//     </div>
//   );
// };

// export default DonaQRCodeTestScan;

import React from 'react'
import MainLayout from '../../layouts/MainLayout'

export default function DonaQRCodeTestScan() {
  return (
    <MainLayout>
    <div>DonaQRCodeTestScan</div>
    </MainLayout>
  )
}
